import { handleRequestResponseError, handleServerNetworkError } from '../../../utils/errorUtils/handleServerNetworkError';
import { CommetsResponseType, projectsAPINEW } from '../../../api/projects-api';
import { setAppStatusAC } from '../../../app/app-reducer';
import { PayloadAction, createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AppRootState } from '../../../app/store';
import { setIsCommentsFetched } from './commentsApp-reducer';

export const fetchCommentsTC_ = createAsyncThunk('comments/fetchComments', async (params: { projectName: string, projectId: number, taskId: number }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    const res = await projectsAPINEW.getItemComments(token, params.projectId, params.taskId)
    thunkAPI.dispatch(setIsCommentsFetched(true))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
    return { comments: res.data, projectName: params.projectName, taskId: params.taskId }
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue(null)
  }
})

export const addAttachmentTC_ = createAsyncThunk('workItem/addPictureToComment', async (params: {
  imgSrc: any, projectId: number, projectName: string, areaPath: string,
  fileName: string, formData: any, taskId: number
}, thunkAPI) => {
  
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  const state = thunkAPI.getState() as AppRootState
  const token = state.auth.token
  try {
    const res = await projectsAPINEW.createAttachment(token, params.projectId, params.areaPath, params.fileName, params.formData)
    const id = res.data[0].id
    const state = thunkAPI.getState() as AppRootState
    let task = state.commentsTaskPart[params.projectName].find(t => t.taskId === params.taskId)
    let text = task?.myCommentText
    if (!text) {
      text = ''
    }
    let newText = text + `<img alt=${params.fileName} src=${params.imgSrc} data-src=${res.data[0].url} />`
    thunkAPI.dispatch(setMyCommentTextAC({ projectName: params.projectName, taskId: params.taskId, text: newText }))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
    return res.data
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue(null)
  }
}
)

export const addCommentTC_ = createAsyncThunk('workItem/addComment', async (params: { projectName: string, projectId: number, taskId: number }, thunkAPI) => {
  thunkAPI.dispatch(setAppStatusAC({ status: 'loading' }))
  thunkAPI.dispatch(setIsCommentsFetched(false))
  const state = thunkAPI.getState() as AppRootState
  const name = `${state.auth.me.firstName} ${state.auth.me.lastName}`
  const accontName = `${state.auth.me.account?.name}`
  const dataName = `${state.auth.me.firstName}/${state.auth.me.lastName}`
  // const accountName = `${state.}`
  const token = state.auth.token
  try {
    const state = thunkAPI.getState() as AppRootState
    let task = state.commentsTaskPart[params.projectName].find(t => t.taskId === params.taskId)
    let text = task?.myCommentText
    if (!text) {
      text = ''
    }
    let parser = new DOMParser()
    let html = parser.parseFromString(text, 'text/html')
    let arr = html.getElementsByTagName("img")
    for (let i = 0; i < arr.length; i++) {
      let serverSrc = arr[i].dataset.src
      if (serverSrc)
        arr[i].src = serverSrc
      arr[i].removeAttribute('data-src')
    }
    
    let newText = new XMLSerializer().serializeToString(html)
    let messageText = `<div>${newText}<div class='data-name' data-name=${dataName}>@${name} from "${accontName}"</div></div>`
    const res = await projectsAPINEW.addComment(token, params.projectId, params.taskId, messageText)
    thunkAPI.dispatch(setMyCommentTextAC({ projectName: params.projectName, taskId: params.taskId, text: '' }))
    thunkAPI.dispatch(fetchCommentsTC_({ projectName: params.projectName, projectId: params.projectId, taskId: params.taskId }))
    thunkAPI.dispatch(setAppStatusAC({ status: 'succeeded' }))
    console.log(res.data)
  } catch (error: any) {
    handleRequestResponseError(error, thunkAPI.dispatch)
    return thunkAPI.rejectWithValue(null)
  }
})

const initialState = {} as CommentsPartStateType

const slice = createSlice({
  name: 'Comments',
  initialState: initialState,
  reducers: {
    setCommentsState(state, action: PayloadAction<{ projectName: string, tasks: Array<CommentsPartType> }>) {
      state[action.payload.projectName] = action.payload.tasks
    },
    setMyCommentTextAC(state, action: PayloadAction<{ projectName: string, taskId: number, text: string }>) {
      let task = state[action.payload.projectName].find(t => t.taskId === action.payload.taskId)
      if (task) {
        task.myCommentText = action.payload.text
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCommentsTC_.fulfilled, (state, action) => {
      if (action.payload) {
        let workItem = state[action.payload.projectName].find(t => t.taskId === action.payload.taskId)
        if (workItem) {
          workItem.commentsData = action.payload.comments
        }
      }
    })
  }
})

export const commentsReducer = slice.reducer
export const { setMyCommentTextAC, setCommentsState } = slice.actions


export type CommentsPartType = {
  taskId: number
  commentsData: CommetsResponseType
  myCommentText: string
}
export type CommentsPartStateType = {
  [key: string]: Array<CommentsPartType>
}
